import { useState, useEffect } from "react";
import { useParams } from "react-router";
import DashboardTable from "./DashboardTable";
import SegmentTable from "./SegmentTable";
import Loader from "../ComponentsGeneral/Loader/Loader";
import PnlSummary from "./PnlSummary";
import Error from "../ComponentsGeneral/Error/ErrorPage";
import SubHeader from "../ComponentsGeneral/Navbar/SubHeader";
import { getPnlData } from "../Services/API/api";
import { error_messages } from "../Constants/constants";
import "./index.css";

export default function HomePage() {
  const [pnlData, setPnlData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(0); // 0 => No error, 1 => Invalid link, 2 => Expired link
  const [selectedSegment, setSelectedSegment] = useState(null);
  const params = useParams();
  useEffect(() => {
    const handleContextmenu = e => {
        e.preventDefault()
    }
    document.addEventListener('contextmenu', handleContextmenu)
    return function cleanup() {
        document.removeEventListener('contextmenu', handleContextmenu)
    }
  }, [])
  useEffect(() => {
    async function getData() {
      try {
        const payload = { u_id: params.id };
        const res = await getPnlData(payload);
        console.log(res)
        if (res.data && res.data.status_code === 1000) {
          setPnlData(res.data);
        } else if (res.data.status_code === 1019) {
          setError(2);
        } else {
          setError(1);
        }
      } catch (e) {
        setError(1);
      } finally {
        setLoading(false);
      }
    }
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <SubHeader data={pnlData} />
      {selectedSegment ? (
        <div className="verified-breadcrumb container mt-3">
          <span
            className="breadcrumb-prev-page"
            onClick={() => setSelectedSegment(null)}
            title="Return to summary page"
          >
            Verified P&L{" "}
          </span>
          {selectedSegment ? (
            <span>
              &gt;{" "}
              <span className="breadcrumb-selected-segment">
                {selectedSegment}
              </span>
            </span>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )}
      <div
        className={`container  mt-3  ${
          selectedSegment ? "segment-wrapper-container" : ""
        }`}
      >
        <div
          className={`d-flex flex-column pnl-wrapper flex-md-row  ${
            selectedSegment ? "segment-top-container" : ""
          }`}
        >
          {loading ? (
            <div className="w-100 d-flex align-items-center justify-content-center">
              <Loader />
            </div>
          ) : (
            <>
              {error ? (
                <div className="w-100 d-flex align-items-center justify-content-center">
                  <Error
                    heading={
                      error === 2
                        ? error_messages.EXPIRED_LINK.header
                        : error_messages.INVALID_LINK.header
                    }
                    message={
                      error === 2
                        ? error_messages.EXPIRED_LINK.message
                        : error_messages.INVALID_LINK.message
                    }
                    subMessage={
                      error === 2
                        ? error_messages.EXPIRED_LINK.sub_message
                        : error_messages.INVALID_LINK.sub_message
                    }
                  />
                </div>
              ) : (
                <>
                  <PnlSummary data={pnlData} />
                  {!selectedSegment ? (
                    <DashboardTable
                      data={pnlData}
                      setSelectedSegment={setSelectedSegment}
                    />
                  ) : (
                    <SegmentTable
                      data={pnlData}
                      selectedSegment={selectedSegment}
                      setSelectedSegment={setSelectedSegment}
                    />
                  )}
                </>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}
